/**
 * Created by Kieran on 06/05/2017.
 */

import axios from 'axios'
import config from '../../config'

let SettingsApi = {

  /**
   * @param model
   * @returns {AxiosPromise}
   */

  getSettings() {
    return axios.get(config.apiUrl + 'settings/')
  },
  putUnitSettings(model) {
    return axios.put(config.apiUrl + 'settings/units/', model);
  },
  putNutritionSettings(model) {
    return axios.put(config.apiUrl + 'settings/nutrition/', model);
  },
  getNutritionSettings() {
    return axios.get(config.apiUrl + 'settings/nutrition/')
  },
  putSettings(model) {
    return axios.put(config.apiUrl + 'settings/', model)
  },
  putPrivacySettings(model) {
    return axios.put(config.apiUrl + 'settings/privacy/', model)
  },
  getNotificationSettings() {
    return axios.get(config.apiUrl + 'settings/notifications/')
  },
  putNotificationSettings(model) {
    return axios.put(config.apiUrl + 'settings/notifications/', model)
  },
  getUnitSettings() {
    return axios.get(config.apiUrl + 'settings/units/')
  },
  getBloodSugarSettings() {
    return axios.get(config.apiUrl + 'settings/blood_sugar/')
  },
  getPrivacySettings() {
    return axios.get(config.apiUrl + 'settings/privacy/')
  },
  updateUserSettings(model) {
    return axios.put(config.apiUrl + 'settings/', model)
  },
  getCardOrder() {
    return axios.get(config.apiUrl + 'settings/cardOrder');
  },
  updateCardOrder(model) {
    return axios.put(config.apiUrl + 'settings/cardOrder', model);
  },
  getHeightSettings() {
    return axios.get(config.apiUrl + 'settings/height/')
  },
  updateHeightSettings(model) {
    return axios.put(config.apiUrl + 'settings/height/', model)
  },
  getFoodDiaryNutritionUnit() {
    return axios.get(`${config.apiUrl}settings/food-diary/nutrition-unit`);
  },
  setFoodDiaryNutritionUnit(model) {
    return axios.put(`${config.apiUrl}settings/food-diary/nutrition-unit`, model);
  }
};

export default SettingsApi



// WEBPACK FOOTER //
// ./src/api/Settings/index.js